export default __webpack_public_path__ + "static/iPhone-fashion-chatbot2-fa6903708be9347b401fa604aa3eda00.mp4";